import {BONUS_CARD_CONSTS, AUTH_CONSTS} from "../constants";

export const initialState = {
    bonusCards: {
        itemsList: [],
        hasMore: true,
        userId: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BONUS_CARD_CONSTS.GET_BONUS_CARDS:
            return {
                ...state,
                bonusCards: {
                    itemsList: action.payload.reset ? action.payload.data : [...state.bonusCards.itemsList, ...action.payload.data],
                    userId: action.payload.userId,
                    hasMore: action.payload.hasMore
                }
            };
        case BONUS_CARD_CONSTS.DELETE_BONUS_CARD:
            return {
                ...state,
                bonusCards: {
                    ...state.bonusCards,
                    itemsList: state.bonusCards.itemsList.filter(bonusCard => bonusCard.id !== action.payload),
                }
            };
        case AUTH_CONSTS.LOG_OUT:
            return initialState;
        default:
            return state;
    }
}
